<template>
  <a-box>
    <l-rows>
      <a-title
        :text="$t('casinos.integrationOptions')"
        size="4"
      />
      <form @submit.prevent="addIntegrationOption">
        <l-rows>
          <l-rows tag="ul">
            <li
              v-for="mappedValue in mappedValues"
              :key="mappedValue.option.id"
            >
              <l-columns
                centered-y
                space="between"
              >
                <dl class="cf-push-configuration__options">
                  <div>
                    <div class="cf-push-configuration__option cf-push-configuration__option--key-value">
                      <dt>{{ mappedValue.option.name }}</dt>
                      <dt>
                        <a-input
                          v-if="mappedValue.option.dataType === 'Integer'"
                          :value="mappedValue.value"
                          type="number"
                          @blur="updateIntegrationOptionValue($event, mappedValue.option)"
                        />
                        <a-input
                          v-if="mappedValue.option.dataType === 'String'"
                          :value="mappedValue.value"
                          type="text"
                          @blur="updateIntegrationOptionValue($event, mappedValue.option)"
                        />
                        <a-input
                          v-if="mappedValue.option.dataType === 'Float'"
                          :value="mappedValue.value"
                          type="number"
                          step="0.001"
                          @blur="updateIntegrationOptionValue($event, mappedValue.option)"
                        />
                        <a-checkbox
                          v-if="mappedValue.option.dataType === 'Boolean'"
                          :value="mappedValue.value"
                          fullwidth
                          @input="updateIntegrationOptionValue($event, mappedValue.option)"
                        />
                      </dt>
                    </div>
                  </div>
                </dl>
                <a-button
                  icon-left="fas fa-trash"
                  variant="primary"
                  type="button"
                  aria-label="Delete integration option"
                  @click="deleteIntegrationOption(mappedValue.option)"
                />
              </l-columns>
            </li>
          </l-rows>
          <l-columns>
            <a-select
              v-model="selectedIntegrationOptionValue"
              fullwidth
              :options="filteredOptions"
            />
            <l-columns-column size="narrow">
              <a-button
                :text="$t('common.add')"
                variant="primary"
              />
            </l-columns-column>
          </l-columns>
        </l-rows>
      </form>
    </l-rows>
  </a-box>
</template>

<script>
  import { ABox, AInput, ACheckbox, AButton, ASelect, ATitle, LColumns, LColumnsColumn, LRows } from 'codefabrik-gui-vue'
  import { useCasinoIntegrationOptionPage } from '@/views/casinos/casinoHooks'

  export default {
    name: 'CasinoIntegrationOptions',
    components: { ABox, ACheckbox, AInput, LRows, ATitle, LColumns, ASelect, LColumnsColumn, AButton },
    props: {
      value: {
        type: Array,
        default () { return [] }
      }
    },
    data () {
      return {
        selectedIntegrationOptionValue: null
      }
    },
    computed: {
      casinoIntegrationOptions () {
        return this.casinoIntegrationOptionPage.casinoIntegrationOptions || []
      },
      options () {
        return [
          {
            label: this.$t('casinos.selectIntegrationOption'),
            value: null
          },
          ...this.casinoIntegrationOptions.map(it => ({
            label: it.name,
            value: it.id
          }))
        ]
      },
      filteredOptions () {
        return this.options.filter(it => !this.value.map(it => it.id).includes(it.value))
      },
      mappedValues () {
        let output = []
        if(this.casinoIntegrationOptions.length === 0)
          return output
        for (const v of this.value) {
          let value = v.value
          const option = this.casinoIntegrationOptions.find(option => option.id === v.id)
          if(option.dataType === "Boolean"){
            value = (v.value === true || v.value === 'true')
          }
          output.push({option: option, value: value})
        }
        return output;
      }
    },
    methods: {
      addIntegrationOption () {
        if (this.selectedIntegrationOptionValue == null) return
        let option = this.casinoIntegrationOptions.find(x => x.id === this.selectedIntegrationOptionValue)
        let value = ""
        if(option.dataType === "Boolean") {
          value = true
        }
        this.$emit('input', [
          ...this.value,
          {id: this.selectedIntegrationOptionValue, value: value}
        ])
        const indexOf = this.filteredOptions.findIndex(it => it.value === this.selectedIntegrationOptionValue) + 1
        const nextOption = this.filteredOptions[Math.min(indexOf, this.filteredOptions.length)]
        this.selectedIntegrationOptionValue = nextOption ? nextOption.value : null
      },
      deleteIntegrationOption (option) {

        this.$emit(
          'input',
          this.value.filter(it => it.id !== option.id)
        )
      },
      updateIntegrationOptionValue (e, option) {
        let value = e
        if(option.dataType !== "Boolean"){
          value = e.target.value
        }
        let id = option.id
        let index = this.value.findIndex((obj => obj.id === id));
        this.value[index].value = value;
        this.$emit(
          'input',
          this.value
        )
      }
    },
    mixins: [useCasinoIntegrationOptionPage({ limit: 0 })]
  }
</script>

<style
  lang="scss"
  scoped
>
@import "../assets/styles";

.has-word-break-all {
  word-break: break-all;
}

.full-height-columns > .cf-columns__column > * {
  height: 100%;
}

h5 {
  font-weight: bold;
}

.cf-push-configuration__option {
  dt {
    color: #676767;
  }
}

.cf-push-configuration__option--key-value {
  display: grid;
  grid-gap: 1.9rem;
  grid-template-columns: 2fr 2fr;
}

.cf-push-configuration__options > div {
  margin-top: 0.5rem;
}

@include widescreen {
  .cf-push-configuration__options {
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(auto-fit, minmax(35rem, 1fr));
  }
}
</style>
